import { Component } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';

@Component({

   selector: 'page-popover-sign',
   templateUrl: 'popover-sign.html'
})

export class PopoverSignPage
{

   private value;
   private callback;


   /** ----- Constructor ----- **/

   constructor( private viewCtrl: ViewController,
                private params: NavParams )
   {

      this.value = this.params.get( 'value' );
      this.callback = this.params.get( 'callback' );

   }


   /** ----- View LifeCycle ----- **/

   onBtnClicked(flag)
   {
      this.callback(flag).then( () => {
         this.viewCtrl.dismiss();
      });
   }

}



// WEBPACK FOOTER //
// ./src/pages/popover-sign/popover-sign.ts